module.exports = __webpack_public_path__ + "img/icon-error.fbe504e4.svg";